<template>
    <div >
        <Card title="费用信息">
            <Form :label-width="120" ref="form" class="mt15">
                <Row>
                    <Col span="12">
                        <FormItem label="保障类型：" class="w600">{{info.policyTimeType==1?'年单':'月单'}}</FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="保障起期：" class="w600">{{info.beginDate}}</FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="保障止期：" class="w600">{{info.endDate}}</FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="保费合计：" class="w600">{{info.amount}}
                        <span v-if="type=='rider'">（包含退款：{{ info.refundAmount }}元）</span>
                        </FormItem>
                    </Col>
                </Row> 
            </Form>
            <el-table class="mt10" ref="table" :data="tableData" border style="width: 100%">
                <el-table-column prop="name" label="设备名称" show-overflow-tooltip width="180"></el-table-column>
                <el-table-column prop="code" label="车架号/发动机号" show-overflow-tooltip width="180"></el-table-column>
                <el-table-column prop="productFactory" label="生产厂家" show-overflow-tooltip width="180"></el-table-column>
                <el-table-column prop="useAddress" label="使用区域" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="feeBearGroup" label="费用承担主体" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="feeBearCode" label="费用承担主体编码" width="150"></el-table-column>
                <el-table-column prop="costBearCode" label="成本承担主体编码" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="price" label="保费（元）" width="180"></el-table-column>
                <el-table-column prop="beginDate" label="保障起期" width="180"></el-table-column>
                <el-table-column prop="endDate" label="保障止期" width="180"></el-table-column>
                <el-table-column v-if="type=='policy'" prop="statusName" label="保障状态" width="100"></el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip width="180"></el-table-column>
            </el-table>
            <Row class="mt10" v-if="tableData.length>0">
                <Col :span="24" class="right">
                    <el-pagination
                        :current-page="pageinfo.page"
                        :page-size="pageinfo.size"
                        :total="pageinfo.total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                    >
                    </el-pagination>
                </Col>
            </Row>
        </Card>
    </div>
    </template>
    <script>
    export default {
        props:{
            info:{
                type: Object,
                default(){
                    return {}
                }
            },
            type:{
                type: String,
                default(){
                    return ''
                }
            },
        },
        data () {
            return {
                loading: false,
                params: {
                },
                status:' ',
                detailList: [],
                tableData:[],
                pageinfo: {
                    page: 1,
                    size: 20,
                    total: 0,
                }
            }
        },
        watch: {
            info: function(newVal,oldVal){
                this.detailList = newVal.detailList;
                this.pageinfo.total = this.detailList.length;
                this.tableData =  this.currentChangePage(this.pageinfo.size,this.pageinfo.page)
            }
        },
        methods:{
            /** 切换每页显示条数 */
            handleSizeChange(val) {
                this.pageinfo.page = 1;
                this.pageinfo.size = val;
                this.tableData = this.currentChangePage(val, this.pageinfo.page);
                this.pageinfo.total = this.detailList.length;
            },
            /** 切换分页 */
            handleCurrentChange(val) {
                this.pageinfo.page = val;
                this.tableData = this.currentChangePage(this.pageinfo.size, val);
                this.pageinfo.total = this.detailList.length;
            },
            // 分页方法
            currentChangePage(size, current) {
                const tablePush = [];
                let array = this.jsonCopy(this.detailList);
                array.forEach((item, index) => {
                    if (size * (current - 1) <= index && index <= size * current - 1) {
                    tablePush.push(item);
                    }
                });
                return tablePush;
            },
        }
    }
    </script>
    <style scoped>
        .content{
            padding:0 15px 15px;
        }
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedForklift/common/supportPlans.vue